// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"3458e35b","835":"38631b15"}[chunkId] + ".chunk.css";
};